// extracted by mini-css-extract-plugin
export var button = "recipeCard-module--button--804f1";
export var cafeFormIntro = "recipeCard-module--cafe-form-intro--f1dbe";
export var card = "recipeCard-module--card--b0009";
export var cardContainer = "recipeCard-module--card-container--5bf1d";
export var cardImage = "recipeCard-module--card-image--b87b1";
export var cardInfo = "recipeCard-module--card-info--9845b";
export var cardTitle = "recipeCard-module--card-title--f69fa";
export var cardWrapper = "recipeCard-module--card-wrapper--31cab";
export var highlight = "recipeCard-module--highlight--92571";
export var redButton = "recipeCard-module--red-button--dad7b";
export var redTransparentButton = "recipeCard-module--red-transparent-button--98c36";
export var title = "recipeCard-module--title--559cf";
export var transparentButton = "recipeCard-module--transparent-button--b2f20";
export var type = "recipeCard-module--type--3dfcc";
export var wrapper = "recipeCard-module--wrapper--be1ec";